import * as THREE from 'three'
import BaseObject from './baseObject'


// Circle Object
// Displays a filled circle with radius at a position
export default class CircleObject extends BaseObject {
  constructor(editor, options = {}) {
    super(editor)

    this.persistable = false
    this.position = new THREE.Vector2(0, 0)
    this.radius = parseFloat(options.radius || 10)
    this.colour = options.colour || '#000000'
    this.opacity = parseFloat(options.opacity || 1.0)

    this.shapeObj = null
    this.objectGeometry = null

    this.sceneObject = new THREE.Object3D()
    this.updateSceneObject()
  }

  /**
   * Dispose the object
   */
  dispose() {
    super.dispose()

    if(this.objectGeometry) {
      this.objectGeometry.dispose()
      this.objectGeometry = null
    }
    this.pointObj = null
  }

  // onBeforeRender
  // Called prior to rendering of the object
  onBeforeRender() {
    super.onBeforeRender()

    if(this.shapeObj) {
      this.shapeObj.position.set(this.position.x, this.position.y, 200)
    }
  }


  // Update the position of the point
  setPosition(pos) {
    this.position.set(pos.x, pos.y)
  }

  // Update the radius of the circle at the point
  // Rebuild the scene object
  setRadius(radius) {
    this.radius = radius
    this.updateSceneObject()
  }


  /**
   * Build the scene object
   */
  updateSceneObject() {
    if(this.objectGeometry) {
      this.objectGeometry.dispose()
      this.objectGeometry = null
    }
    this.shapeObj = null

    this.clearSceneObject()

    this.objectGeometry = new THREE.CircleGeometry(this.radius, 20)
    var circleMaterial = new THREE.MeshBasicMaterial({
      color: this.colour,
      transparent: true,
      opacity: this.opacity,
      side: THREE.DoubleSide
    })
    this.shapeObj = new THREE.Mesh(this.objectGeometry, circleMaterial)
    this.sceneObject.add(this.shapeObj)
  }



}
